/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Socials_OpenInputs */

const en_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.label}`)
};

const ar_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`افتح ${i?.label}`)
};

const bn_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} খুলুন`)
};

const de_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Öffnen Sie ${i?.label}`)
};

const es_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.label}`)
};

const fr_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir ${i?.label}`)
};

const pt_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abra ${i?.label}`)
};

const zh_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`打开${i?.label}`)
};

const tr_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}'ı aç`)
};

const ru_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть ${i?.label}`)
};

const pl_socials_open = /** @type {(inputs: Socials_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otwórz ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Open {label}" |
*
* @param {Socials_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const socials_open = /** @type {((inputs: Socials_OpenInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Socials_OpenInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_socials_open(inputs)
	if (locale === "bn") return bn_socials_open(inputs)
	if (locale === "de") return de_socials_open(inputs)
	if (locale === "es") return es_socials_open(inputs)
	if (locale === "fr") return fr_socials_open(inputs)
	if (locale === "pt") return pt_socials_open(inputs)
	if (locale === "zh") return zh_socials_open(inputs)
	if (locale === "tr") return tr_socials_open(inputs)
	if (locale === "ru") return ru_socials_open(inputs)
	if (locale === "pl") return pl_socials_open(inputs)
	return en_socials_open(inputs)
});